// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RM_ll","importantInfo":"styles_importantInfo__cdy1O"};